import { render, staticRenderFns } from "./IndicatorSellerComponent.vue?vue&type=template&id=5b2c50f2&scoped=true&"
import script from "./IndicatorSellerComponent.vue?vue&type=script&lang=js&"
export * from "./IndicatorSellerComponent.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorSellerComponent.vue?vue&type=style&index=0&id=5b2c50f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c50f2",
  null
  
)

export default component.exports